import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {},
    californiaDataLink: {
      textAlign: "center",
      padding: [34, 32, 0, 32],
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(19),
      letterSpacing: 0.37,
      textDecoration: "underline",
      [theme.breakpoints.up("mobile")]: {
        padding: [32, 140, 0, 140],
      },
      [theme.breakpoints.up("tablet")]: {
        padding: [43, 168, 0, 168],
        fontSize: theme.typography.pxToRem(12),
      },
    },
  }),
  { name: "CaliforniaDataLink" },
);
